import '@/util/array.util'
import '@/util/string.util'

import Vue from 'vue'

Vue.config.devtools = process.env.VUE_APP_ENV !== 'production'
Vue.config.productionTip = false

import App from './App'
import router from './router'
import store from './store'

import Assets from '@/assets'
import ThirdParty from '@/third-party'
import Filters from '@/filters'
import Directives from '@/directives'
import Mixins from '@/mixins'
import Core from '@/components/Core'

Vue.use(Assets)
Vue.use(ThirdParty)
Vue.use(Filters)
Vue.use(Directives)
Vue.use(Mixins)
Vue.use(Core)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

if (process.env.VUE_APP_ENABLE_TAILWIND_DEBUG_SCREENS === 'true') {
  document.body.classList.add('debug-screens')
}
